import { render, staticRenderFns } from "./NonPatientPrescriptionModal.vue?vue&type=template&id=511607d8&"
import script from "./NonPatientPrescriptionModal.vue?vue&type=script&lang=js&"
export * from "./NonPatientPrescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports